






















































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import {get} from 'lodash';
import Axios, {CancelTokenSource} from 'axios';
import {DOCUMENT_SCROLL_SERVICE_INSTANCE} from '@/services/documentscroll.service';
import {EVENT_BUS_INSTANCE} from '@/events/eventbus';
import SelectEvent from '@/types/selectEvent';
import {COLOR_SERVICE_INSTANCE, ColorService} from '@/services/style/color.service';
import {FONT_SERVICE_INSTANCE, FontService} from '@/services/style/font.service';
import AmetrasLabelTemplate from '@/fields/AmetrasLabelTemplate.vue';
import {DYNAMIC_FIELD_RESOLVER_INSTANCE} from '@/fields/dynamic-field-resolver';

@Component({
  name: 'ametras-search-field',
  components: {
    AmetrasLabelTemplate,
    DataTableTemplate: () => import('@/views/datatable/DataTableTemplate.vue'),
  }
})
export default class AmetrasSearchField extends Vue {
  hasAtLeastOneNotDisabledLabel: boolean = false;
  requestRunning: boolean = false;
  searchIconHovered: boolean = false;

  get theme() {
    return this.$vuetify.theme.dark;
  }

  @Prop() fieldDefinition!: DisguiseDto.FTSearchFieldGroup;
  @Prop() errorvalmessages!: string;
  @Prop() errorval!: boolean;
  @Prop() allFieldsReadOnly!: boolean;
  @Prop() dialogOpenExternal!: boolean;
  @Prop() readonly !: boolean;
  @Prop() slotUsed !: boolean;
  @Prop() inputs!: DisguiseDto.FTFieldDto[];
  @Prop() labels!: DisguiseDto.FTFieldDto[];
  @Prop() templateUrl!: string;
  @Prop() dtUrl!: string;
  /** Only for simple grid layout. */
  @Prop() rowSizes!: DisguiseDto.FTSizesDto;
  @Prop({default: false}) hideDetails!: boolean;
  @Prop() referenceName!: string;

  validationMessage: string = '';
  dialogOpen: boolean = false;
  isValid: boolean = true;
  dirty: boolean = false;

  // contains non-hidden fields only
  filteredInputs: DisguiseDto.FTFieldDto[] = [];
  filteredLabels: DisguiseDto.FTFieldDto[] = [];
  cancelToken: CancelTokenSource = Axios.CancelToken.source();
  originalDocumentScrollXOffset: number = 0;
  colorService: ColorService = COLOR_SERVICE_INSTANCE;
  fontService: FontService = FONT_SERVICE_INSTANCE;
  dynamicFieldResolver = DYNAMIC_FIELD_RESOLVER_INSTANCE;

  @Watch('dialogOpenExternal') onDialogOpenExternalChanged() {
    this.dialogOpen = this.dialogOpenExternal;
  }

  @Watch('dialogOpen') onDialogOpen() {
    this.$emit('dialogOpen', this.dialogOpen);
    if (this.dialogOpen) {
      this.originalDocumentScrollXOffset =
          DOCUMENT_SCROLL_SERVICE_INSTANCE.readCurrentDocumentScrollXPosition();
      DOCUMENT_SCROLL_SERVICE_INSTANCE.setDocumentScrollXPosition(0);
    } else {
      DOCUMENT_SCROLL_SERVICE_INSTANCE.setDocumentScrollXPosition(this.originalDocumentScrollXOffset);
    }
  }

  @Watch('inputs') onInputsChanged(newVals: DisguiseDto.FTFieldDto[]) {
    this.filteredInputs = newVals.filter((element) => (!element.hidden));
  }

  @Watch('labels') onLabelsChanged(newVals: DisguiseDto.FTFieldDto[]) {
    this.filteredLabels = newVals.filter((element) => (!element.hidden));
    let hasAtLeastOneWritableLabel = false;
    for (const currentLabel of this.filteredLabels || []) {
      if (!currentLabel.disable && !currentLabel.readOnly) {
        hasAtLeastOneWritableLabel = true;
        break;
      }
    }
    this.hasAtLeastOneNotDisabledLabel = hasAtLeastOneWritableLabel;
  }

  created() {
    // init values
    this.filteredInputs = (this.inputs || []).filter((element) => (!element.hidden));
    this.filteredLabels = (this.labels || []).filter((element) => (!element.hidden));
    let hasAtLeastOneWritableLabel = false;
    for (const currentLabel of this.filteredLabels || []) {
      if (!currentLabel.disable && !currentLabel.readOnly) {
        hasAtLeastOneWritableLabel = true;
        break;
      }
    }
    this.hasAtLeastOneNotDisabledLabel = hasAtLeastOneWritableLabel;
  }

  beforeDestroy() {
    // Removes all listeners for this search field
    EVENT_BUS_INSTANCE.$off(this.getFinishedEventName());
  }

  mounted() {
    /** This is a layout hack required for usage inside the form template. We hide the
     *  parent v-col of this search field and insert all search field v-cols
     *  (= the input and label fields of this search field) directly below the v-row.
     *  This way the fields are treated like normal ui fields.
     *
     *  Before:
     *  <v-row>
     *      <v-col>
     *          <searchfield>
     *              <v-col> <input> </input> <v-col>
     *              ... // other input and label fields
     *           <searchfield>
     *      </v-col>
     *  <v-row>
     *
     *  After:
     *  <v-row>
     *      <v-col> <input> </input> <v-col>
     *      ... // other input and label fields
     *      <v-col><searchfield></searchfield></v-col> // this column is hidden
     *  <v-row>
     */

    if (!this.slotUsed && !this.fieldDefinition.fieldGroupLabel) {
      if (this.$el.parentElement && this.$el.parentElement.parentElement) {
        this.$el.parentElement.classList.add('d-none');
        if (Array.isArray(this.$refs.colInput)) {
          for (const element of this.$refs.colInput) {
            this.$el.parentElement.parentElement.insertBefore(element as Node,
                this.$el.parentElement);
          }
        }
        if (Array.isArray(this.$refs.colSearch)) {
          for (const element of this.$refs.colSearch) {
            this.$el.parentElement.parentElement.insertBefore(element as Node,
                this.$el.parentElement);
          }
        }
      }
    }
  }

  mouseEnter() {
    this.searchIconHovered = true;
  }

  mouseLeave() {
    this.searchIconHovered = false;
  }

  onSearchFieldIconClick() {
    if (!this.readonly) {
      this.dialogOpen = true;
    }
  }

  onRefreshFieldIconClick() {
    if (this.readonly && this.hasAtLeastOneNotDisabledLabel) {
      this.dirty = true; // force refresh
      this.search();
    }
  }

  handleData(entry: any, silent: boolean = false, triggerSearch: boolean = true) {
    let valuesChanged = false;
    for (const input of this.inputs) {
      const propertyPath = input.foreignName || input.fieldName || '';
      const inputForeignNameValueRaw = get(entry, propertyPath);
      const inputForeignNameValue = inputForeignNameValueRaw !== undefined ?
          inputForeignNameValueRaw : undefined;
      if (inputForeignNameValue !== undefined) {
        valuesChanged = this.updateField(input, String(inputForeignNameValue), silent) || valuesChanged;
      }
    }
    for (const label of this.labels) {
      const propertyPath = label.foreignName || label.fieldName || '';
      const labelForeignNameValueRaw = get(entry, propertyPath);
      const labelForeignNameValue = labelForeignNameValueRaw !== undefined ?
          labelForeignNameValueRaw : undefined;
      if (labelForeignNameValue !== undefined) {
        this.updateField(label, String(labelForeignNameValue), silent);
      }
    }

    // Trigger search to validate
    if (triggerSearch && valuesChanged) {
      this.search();
    }
    this.dialogOpen = false;
    this.$forceUpdate();
    if (valuesChanged) {
      this.$emit('dirty', true);
    }
  }

  search(selectEvent?: SelectEvent) {
    if (!this.dirty && !selectEvent) {
      return;
    }
    const {queryParams, doSearch} = this.fillQueryParams(selectEvent);
    if (doSearch) {
      this.cancelToken.cancel(); // cancel previous requests
      this.cancelToken = Axios.CancelToken.source(); // generate new search token

      this.requestRunning = true;
      HTTP_SERVICE_INSTANCE.getAxios()
          .get(`${this.templateUrl}`, {
            params: queryParams,
            cancelToken: this.cancelToken.token
          })
          .then((response) => {
            let responseEntry = response.data;
            if (Array.isArray(responseEntry)) {
              responseEntry = responseEntry.length === 1 ? responseEntry[0] : null;
            }
            if (responseEntry) {
              this.handleData(responseEntry, false, false);
              this.$emit(this.getFinishedEventName(), response);
              if (this.referenceName) {
                const field = (this.$refs[this.referenceName] as Vue);
                if (Array.isArray(field)) {
                  field[0].$emit('internalUpdate');
                }
              }
              EVENT_BUS_INSTANCE.$emit(this.getFinishedEventName(), response);
              this.isValid = true;
              this.validationMessage = '';
            } else {
              this.isValid = false;
              this.validationMessage = 'Keinen Datensatz gefunden.';
              this.clearLabels();
            }
            this.dirty = false;
            this.requestRunning = false;
          }, (error) => {
            if (!error || !error.__CANCEL__) {
              this.isValid = false;
              this.validationMessage = 'Keinen Datensatz gefunden.';
            }
            this.requestRunning = false;
          });
    } else {
      this.isValid = true;
      this.validationMessage = '';
      this.clearLabels();
    }
  }

  fillQueryParams(selectEvent: SelectEvent | undefined) {
    const queryParams: { [key: string]: string } = {};
    let doSearch = false;
    if (selectEvent) {
      for (const param of selectEvent?.params) {
        if (param.parameter) {
          queryParams[param.parameter] = (param.value || '');
        }
      }
      doSearch = true;
    } else {
      for (const field of this.inputs || []) {
        const hasValue = (field.value !== null && field.value !== undefined) && ((field.value + '' || '').length > 0);
        if (field.foreignName && hasValue) {
          queryParams[field.foreignName] = (field.value + '' || '');
          // only search if at least one non hidden/disabled field is filled
          if (!field.hidden && !field.disable) {
            doSearch = true;
          }
        }
      }
    }
    return {queryParams, doSearch};
  }

  updateField(input: DisguiseDto.FTFieldDto, entry: string, silent: boolean): boolean {
    const oldValue = input.value + '' || '';
    input.value = entry;
    if (oldValue.localeCompare(input.value) !== 0) {
      if (!silent) {
        this.dirty = true;
        return true;
      }
    }
    return false;
  }

  handleChange(event: any) {
    this.dirty = true;
    this.$emit('dirty', true);
    this.$emit('change', event);
  }

  handleBlur(event: any) {
    this.$emit('blur', event);
    // legacy behaviour without AFFE
    if (!this.referenceName || this.referenceName.length === 0) {
      this.search();
    }
  }

  private getFinishedEventName() {
    return 'searchFinished-' + this.referenceName;
  }

  private clearLabels() {
    for (const label of this.labels) {
      this.updateField(label, '', true);
    }
  }


}
